export default __webpack_public_path__ + "static/media/icon-leave-management.f5ab33f6.svg";